var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'version_en': _vm.language == 'en'},attrs:{"id":"app"}},[(_vm.meta && !_vm.isEmptyObject(_vm.meta))?void 0:_vm._e(),_c('div',{key:_vm.Key},[_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }